export const getEtodErea = (info) => {
  if (info && info.rwy_area) {
    return info.rwy_area.slice(-2);
  }

  return "-";
};
